import { useEffect, useState } from "react"
import { GetActiveClientsByTherapist, GetActiveTherapists } from "../Shared/Services";
import { Button, Col, Row, Select, Tooltip } from "antd";
import PediPlayPageHeader from "../Shared/UI/PediplayPageHeader";
import ClientByProviderTable from "./ClientByProviderTable";
import { dropdownSize, iconSize, textInputSize } from "../Shared/UI/jsx";
import { ExportOutlined } from "@ant-design/icons";
import { countyTransform, exportToCSV, handleDiscipline } from "../Shared/Functions";

const { Option } = Select;

const ClientsByProvider = props => {
    const [providers, setProviders] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState();
    const [providerLoading, setProviderLoading] = useState(true);

    const [data, setData] = useState([]);
    const [highlighted, setHighlighted] = useState();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        GetActiveTherapists()
            .then((res) => {
                setProviders(res.data);
            })
            .finally(() => {
                setProviderLoading(false);
            })
    }, []);

    useEffect(() => {
        if(!selectedProvider) return;

        setLoading(true);
        console.log(selectedProvider);

        GetActiveClientsByTherapist(selectedProvider.id)
            .then((res) => {
                setData(res.data);
                setHighlighted(res.data[0]);
            })
            .finally(() => {
                setLoading(false)
            })
    }, [selectedProvider])

    const handleRowOnClick = record => {
        setHighlighted(record);
    }

    const extra = (
        <div style={{ textAlign: 'end' }}>
            <Tooltip title="Export" placement="top">
                <Button 
                    type="link"
                    disabled={!selectedProvider}
                    icon={<ExportOutlined style={iconSize} />}
                    onClick={() => {
                        const fileName = `ClientByProvider-${selectedProvider?.lastName}_${selectedProvider?.preferredName}`;
                        exportToCSV(fileName, data, {
                            exclude: ["id"],
                            transforms: {
                                county: countyTransform
                            }
                        });
                    }}
                />
            </Tooltip>
        </div>
    )

    return (
        <div>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <PediPlayPageHeader 
                        title={'Clients by Provider'}
                        props={props}
                        loading={providerLoading}
                        extra={extra}
                    />
                </Col>
                <Col span={24}>
                    <Select
                        style={dropdownSize}
                        placeholder="Select a provider"
                        showSearch
                        onChange={(value, option) => {
                            const provider = providers?.find(p => p.id === value);
                            setSelectedProvider(provider);
                        }}
                        filterOption={(input, option) => 
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {providers.map(opt => (
                            <Option key={opt.id} value={opt.id} label={`${opt.lastName} ${opt.preferredName} (${handleDiscipline(opt.discipline)})`}>
                                {opt.lastName} {opt.preferredName} ({handleDiscipline(opt.discipline)})
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col span={24}>
                {selectedProvider &&
                    <ClientByProviderTable loading={loading} highlighted={highlighted} clients={data} handleRowOnClick={handleRowOnClick} />
                }
                </Col>
            </Row>
        </div>
    )
}

export default ClientsByProvider;